import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () =>{
    const Table = { ...Tables.Table };
    Table.tableColumns = [
        {
            prop: 'farm_name',
            label: i18n.t('common_words.farm'),
            minWidth: 110,
            align: 'left',
            sortable: true,
        },
        {
            prop: 'lot_name',
            label: i18n.t('common_words.allotment'),
            minWidth: 80,
            align: 'center',
            sortable: true,
        },
        {
            prop: 'total_plants_seeds',
            label: i18n.t('sowing.total_plants_seeds_planted'),
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds
                );
            },
        },
        {
            prop: 'total_plants_seeds_pruning',
            label: i18n.t('sowing.total_plants_seeds_planted_pruning'),
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds_pruning
                );
            },
        },
        {
            prop: 'total_plants_seeds_replant',
            label: i18n.t('sowing.total_plants_seeds_replant'),
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_plants_seeds_replant
                );
            },
        },
        {
            prop: 'current_population',
            label: i18n.t('sowing.current_population'),
            minWidth: 80,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.current_population
                );
            },
        },
        {
            prop: 'total_area_planted',
            label: `${i18n.t('sowing.total_area_planted')} (Ha)`,
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_area_planted
                );
            },
        },
        {
            prop: 'total_area_pruning',
            label: `${i18n.t('sowing.total_area_pruning')} (Ha)`,
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.total_area_pruning
                );
            },
        },
        {
            prop: 'percentage_of_dead_plants_seeds',
            label: i18n.t('sowing.percentage_of_dead_plants_seeds'),
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.percentage_of_dead_plants_seeds
                );
            },
        },
        {
            prop: 'percentage_of_replanted_plants_seeds',
            label: i18n.t('sowing.percentage_of_replanted_plants_seeds'),
            minWidth: 130,
            align: 'center',
            sortable: true,
            formatter: (row) => {
                return Formatter.formatNumber(
                    row.percentage_of_replanted_plants_seeds
                );
            },
        },
    ];
    const Search = { ...Tables.Search };

    return { Table, Search }
}
export default configTable;